import React from 'react';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Portfolio from './components/Portfolio';
import Skills from './components/Skills';
import './styles/App.css';

function App() {
	return (
		<div className='app'>
			<Navbar />
			<Hero />
			<About />
			<Skills />
			<Portfolio />
			<Contact />
			<Footer />
		</div>
	);
}

export default App;
